import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'

import Button from '../Button'

import './PlusButton.less'

const COMPONENT_CLASS = 'nmc-button-plus'

export default class PlusButton extends React.Component {
  render () {
    const headerClass = classnames(
      COMPONENT_CLASS, this.props.className || [],
      {[`nmc-button-plus-${this.props.size}`]: this.props.size}
    )
    const onlyIcon = this.props.onlyIcon
    if (onlyIcon) {
      return (
        <div className={headerClass} />
      )
    } else {
      return (
        <Button
          {...this.props}
          disabled={this.props.disabled}
          onClick={this.props.onClick}
          className={headerClass}
        />
      )
    }
  }
}

PlusButton.propTypes = {
  size: PropTypes.string
}



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/PlusButton/index.js